module.exports = __webpack_public_path__ + "img/223.da898195.jpg";